// extracted by mini-css-extract-plugin
export default {"canvas-rect":"qrscanner_canvas-rect__KuuPf"};